import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";

import RolesBulkActionsSelectedItem from "./SelectedRoleItem";
import RolesBulkActionsConfirmActionForm from "./ConfirmActionForm";
import { RolesBulkActionsAnalyticsPayload, RolesBulkActionsSelectedAction } from "./types";
import { RolesMutationVariables } from "./useRolesBulkActions/types";
import { RoleView } from "../types";

type RolesBulkActionsConfirmationViewProps = {
  applicableItems: RoleView[];
  skippedItems: RoleView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: RolesBulkActionsSelectedAction;
  onConfirm: (
    mutationVariables: RolesMutationVariables,
    analyticsPayload: RolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
};

const RolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
}: RolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <RolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <RolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default RolesBulkActionsConfirmationView;
